import React, { Component } from 'react';
import PropTypes from 'prop-types';
import EventEmitter from 'events';
import NotificationSystem from 'react-notification-system';

class NotificationProvider extends Component {
  static propTypes = {
    children: PropTypes.node,
  };

  static defaultProps = {
    children: '',
  };

  static childContextTypes = {
    addNotification: PropTypes.func,
    removeNotification: PropTypes.func,
    clearNotifications: PropTypes.func,
  };

  getChildContext() {
    return {
      addNotification: this.addNotification,
      removeNotification: this.removeNotification,
      clearNotifications: this.clearNotifications,
    };
  }

  componentDidMount() {
    EventEmitter.prototype.on('showNotification', this.addNotification);
    EventEmitter.prototype.on('removeNotification', this.removeNotification);

    window.addEventListener('show-notification', this.processAddNotificationEvent);
  }

  componentWillUnmount() {
    EventEmitter.prototype.removeListener('showNotification', this.addNotification);
    EventEmitter.prototype.removeListener('removeNotification', this.removeNotification);

    window.removeEventListener('show-notification', this.processAddNotificationEvent);
  }

  _renderChildren(children) {
    return (
      <ul style={{ 'padding-left': '16px', 'font-size': '12px' }}>
        {children.map(child => <li>{child}</li>)}
      </ul>
    );
  }

  addNotification = (options) => {
    if (Array.isArray(options.children) && options.children.length) {
      options.children = this._renderChildren(options.children);
    }

    this._notificationSystem.addNotification(Object.assign({
      title: 'Error',
      message: 'An unknown error has occurred',
      level: 'error',
      autoDismiss: 5,
      position: 'tc',
      uid: null,
    }, options));
  };

  processAddNotificationEvent = (event) => this.addNotification(event.detail);

  removeNotification = (uid) => {
    this._notificationSystem.removeNotification(uid);
  };

  clearNotifications = () => {
    this._notificationSystem.clearNotifications();
  };

  render() {
    const style = {
      MessageWrapper: {
        DefaultStyle: {
          margin: 0,
          padding: 0,
          // Wrap lines on "\n"
          whiteSpace: 'pre-wrap',
        },
      },
    };
    return (
      <div>
        {this.props.children}
        <NotificationSystem ref={(ref) => { this._notificationSystem = ref; }} style={style} />
      </div>
    );
  }
}

export default NotificationProvider;
